import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ToolbarPrimaryComponent } from './toolbar-primary.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ToolbarPrimaryComponent],
  exports: [ToolbarPrimaryComponent],
})
export class ToolbarPrimaryModule {}
export { ToolbarPrimaryComponent } from './toolbar-primary.component';
